import { render, staticRenderFns } from "./PatentAnnuityEpoForm.vue?vue&type=template&id=4a021bb5&"
import script from "./PatentAnnuityEpoForm.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityEpoForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnuityEpoForm.vue?vue&type=style&index=0&id=4a021bb5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports